import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectAssetById, setEditId } from "../../../store/community/assetsSlice";
import {destroyAsset, fetchAsset, toggleShow} from "../../../actions/community/assetsActions";
import communityUrls from "../../../configs/community/communityUrls";

import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Details from "./_partials/_Details";
import {ButtonDestroy, ButtonEdit, ButtonToggleShow} from "../../../componets/Buttons";
import { fetchCategories } from "../../../actions/community/categoriesActions";
import {HiddenTag} from "../../../componets/Tags/HiddenTag";

const TARGET = 'assets';

const Show: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const asset = useAppSelector(state => id ? selectAssetById(state, id) : undefined);
  const { app_id } = useParams();

  useEffect(() => {
    dispatch(fetchCategories({ params: { app_id: app_id, target: TARGET } }));
  }, [app_id, dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(fetchAsset(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    dispatch(setEditId(id));
  }

  function onClickDestroy() {
    handleDestroy(id).catch(console.error);
  }

  function onToggleShow(id: any, published: boolean) {
    dispatch(toggleShow({ id, published: published }));
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAsset(id));

    if (destroyAsset.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(communityUrls.assetsPath()), 1000);
    }

    if (destroyAsset.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function StatusTag() {
    if (!asset) return null;

    return <HiddenTag key={`show-tag-${asset.id}`} hidden={!asset.published} />
  }

  return (
    <PageLayout className='v-assets-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            asset &&
              <SummaryShow
                title={asset.title}
                subtitle={<StatusTag />}
                image={asset.thumbnail_url}
                createdAt={asset.created_at}
                updatedAt={asset.updated_at}
                publishedAt={asset.published_at}
                className='v-mb-15'
                actions={[
                  <ButtonToggleShow
                    key={`show-${asset.id}`}
                    onClick={() => onToggleShow(asset.id, asset.published)}
                    state={asset.published}
                  />,
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />,
                ]}
              />
          }
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='stickers'
          items={[
            { label: 'Details', key: 'details', children: <Details asset={asset} /> },
          ]}
        />
      </div>

      <SidebarShow id={id} />

      <Edit />
    </PageLayout>
  )
}

export default Show;
